import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("navContact")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                Have questions or feedback? We are here to help. Please note that we are an independent resource and not the official AllChinaBuy support team.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Important Notice</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  This website is an independent informational resource. We are not affiliated with AllChinaBuy and cannot provide support for orders, shipping issues, or account problems on the AllChinaBuy platform.
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  For issues related to your AllChinaBuy account, orders, or shipments, please contact AllChinaBuy directly through their official support channels.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">What We Can Help With</h2>
                <ul className="space-y-3 text-sm text-foreground-700">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span>Questions about our website content or guides</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span>Feedback on articles or suggestions for improvements</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span>Reporting outdated information or broken links</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </span>
                    <span>General inquiries about our editorial policies</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Visit Main Website</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                For all AllChinaBuy related services including placing orders, tracking shipments, and accessing your account, please visit the official website.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
              >
                {t("ctaVisitMain")} <i className="ri-arrow-right-up-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}